class PhoneUtils {
	static onlyNumbers = value => {
		return String(value || "").replace(/\D/g, "");
	};

	static isValidPhone = phone => {
		const digits = PhoneUtils.onlyNumbers(phone);

		return digits.length === 10 || digits.length === 11;
	};

	static isValidTelephone = phone => {
		const digits = PhoneUtils.onlyNumbers(phone);

		return digits.length === 10;
	};

	static isValidCellphone = phone => {
		const digits = PhoneUtils.onlyNumbers(phone);

		return digits.length === 11;
	};

	static getTelephoneMask = () => {
		return [
			"(", /\d/, /\d/, ")",
			" ", /\d/, /\d/, /\d/, /\d/,
			"-", /\d/, /\d/, /\d/, /\d/
		];
	};

	static getCellphoneMask = () => {
		return [
			"(", /\d/, /\d/, ")",
			" ", /\d/, /\d/, /\d/, /\d/, /\d/,
			"-", /\d/, /\d/, /\d/, /\d/
		];
	};

    static cleanPhone(phone) {
		return phone.replace(/[^0-9]/g, '');
	}

    static formatPhone(phone) {
        const cleaned = this.cleanPhone(phone);
        if (cleaned.length === 8) {
            return cleaned.substring(0, 4) + '-' + cleaned.substring(4);
        } else if (cleaned.length === 9) {
            return cleaned.substring(0, 5) + '-' + cleaned.substring(5);
        }
        return phone;
	}
}

export default PhoneUtils;